import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Ertigaonrentinmumbai() {



const cardData = {
  keyword: " Ertiga On Rent in Mumbai",

headingDescription:
  "Omshree Cab offers comfortable and affordable Ertiga on rent in Mumbai for travelers seeking a spacious and convenient ride for city travel, airport transfers, family outings, group trips, or outstation journeys. The Maruti Suzuki Ertiga is a popular multi‑purpose vehicle known for its roomy interiors, excellent fuel efficiency, smooth ride, and seating capacity, making it an ideal choice for families, friends, and corporate travel. With flexible rental options including one‑way bookings, round trips, hourly packages, and full‑day rentals, we provide transparent pricing and easy online booking. Each Ertiga in our fleet is regularly maintained, air‑conditioned, and driven by professional chauffeurs familiar with Mumbai’s traffic and routes. With punctual pickups from any address in Mumbai—whether at the airport, railway station, hotel, or residence—and 24/7 customer support, renting an Ertiga becomes a stress‑free experience.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of the most iconic landmarks in Mumbai, located along the Arabian Sea in South Mumbai. Visitors enjoy admiring the historic arch, capturing photographs, and taking ferry rides to Elephanta Island. The vibrant Colaba area around the Gateway is filled with street markets, cafes, and heritage buildings. Renting an Ertiga makes it easy and comfortable for families or groups to reach this popular destination without worrying about parking or traffic."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal promenade along the Arabian Sea, popularly called the Queen’s Necklace because of the lights that sparkle at night. Visitors often come here for evening walks, sunset views, and leisurely drives. The long stretch connects several landmarks of South Mumbai, making it a popular city route. A rented Ertiga provides a smooth and comfortable ride for group sightseeing and leisure drives along this iconic boulevard."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most beloved beaches, known for its sandy shores, seaside breeze, and famous street food such as pav bhaji, bhel puri, and pani puri. Tourists and locals alike visit to relax, enjoy sunsets, and spend time with family and friends. Renting an Ertiga offers ample seating and space for luggage, making it a perfect choice for family trips to Juhu Beach and nearby attractions."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu shrine dedicated to Lord Ganesha and one of the most visited spiritual sites in Mumbai. Devotees and tourists visit to seek blessings and experience the serene atmosphere, especially during festivals like Ganesh Chaturthi. A rented Ertiga ensures comfortable travel to the temple for families and groups while avoiding the hassle of crowded public transport and parking issues."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern engineering marvel connecting Bandra and Worli across the Arabian Sea. The bridge offers breathtaking views of the sea and city skyline, especially at sunset or nighttime when illuminated. Driving across the Sea Link is an unforgettable experience for visitors. Renting an Ertiga ensures a spacious and enjoyable ride across this scenic route, perfect for groups and family trips."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous Islamic shrine located on an islet off the coast of Mumbai, connected to the mainland by a narrow walkway during low tide. Visitors from diverse backgrounds come to offer prayers and experience the peaceful surroundings and sea views. Renting an Ertiga provides a comfortable journey and easy access to this spiritual destination without stress or transport issues."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut caves located on Elephanta Island and are known for their intricate sculptures dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract visitors interested in history, culture, and architecture. Visitors take a ferry from the Gateway of India to reach the island. Renting an Ertiga provides reliable and comfortable transport to the ferry departure point, making your cultural journey more enjoyable."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a vast forest reserve within Mumbai that offers trekking trails, nature walks, wildlife spotting, and visits to the historic Kanheri Caves. Nature lovers and families spend leisurely time exploring the greenery and peaceful surroundings. Renting an Ertiga allows you to enjoy a comfortable day‑trip experience with friends or family while exploring this natural attraction."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively shopping street in South Mumbai known for its vibrant markets, fashion stalls, handicrafts, accessories, and local eateries. Visitors enjoy browsing through a variety of products and stopping for a bite at local cafes. Renting an Ertiga ensures easy and spacious travel to this bustling marketplace and back, especially for group shopping outings."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are landscaped terraced gardens located on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors come here for walks, photography, and relaxation amidst greenery. Renting an Ertiga provides comfortable and convenient access, making it ideal for group sightseeing in this scenic area."
  }
],



services: [
{
name: "Ertiga on Rent Mumbai",
description: "Ertiga on rent in Mumbai offers spacious and comfortable MPV transportation for passengers traveling within the city or to nearby destinations. The Maruti Ertiga is known for its smooth driving experience, excellent mileage, and comfortable seating for families or small groups. Professional drivers ensure punctual pickup and safe driving across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips, corporate travel, and weekend getaways. Air-conditioned interiors ensure relaxed journeys. Flexible booking options allow easy reservations anytime."
},
{
name: "Maruti Ertiga Rental Mumbai",
description: "Maruti Ertiga rental in Mumbai provides reliable and comfortable transportation for passengers seeking spacious vehicles for city travel and outstation trips. The Ertiga offers ample legroom, smooth suspension, and fuel-efficient performance suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, offices, hotels, and transport hubs. Ideal for airport transfers, family travel, and corporate trips. Spacious seating ensures comfortable rides for passengers. Easy booking options allow quick and convenient reservations."
},
{
name: "Ertiga Cab Service Mumbai",
description: "Ertiga cab service in Mumbai provides dependable MPV transportation for passengers traveling in groups or families. The Maruti Ertiga offers comfortable seating and smooth travel on city roads and highways. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for airport transfers, business travel, and tourism visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick ride scheduling anytime."
},
{
name: "Ertiga Taxi Mumbai",
description: "Ertiga taxi in Mumbai offers comfortable group travel with spacious seating and smooth ride quality. The Maruti Ertiga is perfect for family travel, airport transfers, and corporate rides. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for long-distance trips and city travel. Air-conditioned interiors ensure relaxed journeys for passengers. Easy booking options allow convenient taxi reservations."
},
{
name: "Ertiga Car Hire Mumbai",
description: "Ertiga car hire in Mumbai provides comfortable and affordable MPV transportation for passengers traveling with family or groups. The Maruti Ertiga offers spacious seating and smooth highway travel suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, and transport hubs. Ideal for family vacations, business trips, and sightseeing tours. Spacious luggage capacity ensures convenient travel. Flexible hiring options allow easy ride scheduling."
},
{
name: "Ertiga Airport Cab Mumbai",
description: "Ertiga airport cab in Mumbai provides reliable airport transportation with spacious seating and luggage capacity. The vehicle ensures comfortable travel between airport terminals and city locations. Professional drivers monitor flight schedules to provide punctual pickup and drop services. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for business travelers, tourists, and family airport transfers. Air-conditioned interiors ensure comfortable journeys with luggage. Flexible booking options allow advance reservations."
},
{
name: "Ertiga Outstation Cab Mumbai",
description: "Ertiga outstation cab in Mumbai offers comfortable long-distance travel for passengers planning trips outside the city. The Maruti Ertiga provides smooth highway performance and spacious seating ideal for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, and hotels. Ideal for pilgrimage tours, weekend trips, and family vacations. Large luggage space ensures convenience for travelers. Flexible one-way and round-trip booking options make travel planning easy."
},
{
name: "Ertiga One Way Cab Mumbai",
description: "Ertiga one way cab in Mumbai offers economical travel for passengers heading to nearby cities without return charges. The vehicle provides comfortable seating and smooth driving experience on highways and city roads. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for intercity travel, airport transfers, and tourism visits. Spacious interiors ensure relaxed journeys for passengers. Flexible booking options allow quick reservations."
},
{
name: "Ertiga Round Trip Taxi Mumbai",
description: "Ertiga round trip taxi in Mumbai offers convenient travel for passengers planning return journeys to nearby destinations. The Maruti Ertiga provides comfortable seating and smooth highway performance for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for weekend trips, family tours, and business travel. Air-conditioned interiors ensure comfortable journeys. Flexible round-trip packages allow convenient travel planning."
},
{
name: "Cheap Ertiga Rental Mumbai",
description: "Cheap Ertiga rental in Mumbai offers budget-friendly MPV transportation for passengers looking for affordable group travel. The Maruti Ertiga provides spacious seating and comfortable travel for city and outstation journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for family travel, corporate rides, and airport transfers. Comfortable interiors ensure relaxed journeys. Flexible rental options allow easy booking anytime."
},
{
name: "Ertiga Family Cab Mumbai",
description: "Ertiga family cab in Mumbai provides spacious transportation ideal for families traveling together. The Maruti Ertiga offers comfortable seating and smooth travel suitable for long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for family vacations, temple visits, and weekend trips. Large luggage space ensures convenient travel with bags. Flexible booking options allow easy ride reservations."
},
{
name: "Ertiga Corporate Cab Mumbai",
description: "Ertiga corporate cab in Mumbai provides reliable transportation for business executives and company employees. The vehicle offers spacious seating and professional travel suitable for corporate rides. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from offices, hotels, airports, and business districts. Ideal for corporate meetings, airport transfers, and staff travel. Comfortable interiors ensure relaxed journeys for professionals. Flexible booking options allow scheduled corporate rides."
},
{
name: "Ertiga Per Km Rate Mumbai",
description: "Ertiga per km rate in Mumbai offers transparent pricing for passengers traveling in comfortable Maruti Ertiga vehicles. The MPV provides spacious seating and smooth travel for both city and highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for outstation trips, corporate travel, and family tours. Comfortable interiors ensure relaxed journeys for passengers. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Ertiga Cab Booking Mumbai",
description: "Ertiga cab booking in Mumbai allows passengers to easily reserve spacious MPV transportation for city and outstation travel. Online and phone booking options provide quick ride confirmation. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, and airport terminals. Ideal for family travel, corporate trips, and airport transfers. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow easy ride scheduling anytime."
},
{
name: "Ertiga Taxi Booking Mumbai",
description: "Ertiga taxi booking in Mumbai provides convenient ride reservations for passengers looking for comfortable MPV transportation. The Maruti Ertiga offers spacious seating and smooth travel suitable for city rides and long journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, tourism visits, and family travel. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick taxi reservations anytime."
}
],

tableData: [
["Ertiga on Rent Mumbai","Maruti Ertiga Rental Mumbai"],
["Ertiga Cab Service Mumbai","Ertiga Taxi Mumbai"],
["Ertiga Car Hire Mumbai","Ertiga Airport Cab Mumbai"],
["Ertiga Outstation Cab Mumbai","Ertiga One Way Cab Mumbai"],
["Ertiga Round Trip Taxi Mumbai","Cheap Ertiga Rental Mumbai"],
["Ertiga Family Cab Mumbai","Ertiga Corporate Cab Mumbai"],
["Ertiga Per Km Rate Mumbai","Ertiga Cab Booking Mumbai"],
["Ertiga Taxi Booking Mumbai","Maruti Ertiga Hire Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable & Spacious Ertiga MPV",
    WhyChoosedescription: "Maruti Ertiga is one of the most popular MPV cars for rental in Mumbai because of its spacious seating and smooth ride quality. It is ideal for family travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Affordable Rental Pricing",
    WhyChoosedescription: "Omshree Cabs offers affordable and transparent pricing for Ertiga rentals in Mumbai. Customers are informed about per-kilometer charges, toll costs, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Ertiga Cab Availability",
    WhyChoosedescription: "Our Ertiga rental service in Mumbai is available 24 hours a day. Whether you need an early morning airport drop or late-night pickup, our cabs are always ready."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "All Ertiga cars in our fleet are regularly serviced, cleaned, and sanitized to ensure passengers enjoy a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Ideal for Local & Outstation Travel",
    WhyChoosedescription: "Ertiga is perfect for city travel within Mumbai as well as outstation journeys to destinations like Pune, Lonavala, Nashik, Shirdi, Surat, and Mahabaleshwar."
  },
  {
    WhyChooseheading: "Professional Chauffeur Drivers",
    WhyChoosedescription: "Our trained drivers are experienced in navigating Mumbai roads and highways, ensuring safe driving and a smooth travel experience."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai for hassle-free travel."
  },
  {
    WhyChooseheading: "Trusted MPV Rental Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Ertiga car rentals in Mumbai because of our punctual service, comfortable vehicles, and professional drivers."
  }
]
};

const faqData = [
  { question: "Do you provide Ertiga on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Maruti Ertiga rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of Ertiga?", answer: "Maruti Ertiga is a 6 to 7 seater MPV suitable for families and small groups." },
  { question: "Can I book Ertiga for Mumbai Airport transfer?", answer: "Yes, Ertiga cars are commonly used for Mumbai Airport pickup and drop services because of their spacious seating and luggage capacity." },
  { question: "Is Ertiga suitable for long-distance travel?", answer: "Yes, Ertiga is comfortable for long-distance journeys and is widely used for outstation travel from Mumbai." },
  { question: "Do you provide Ertiga for outstation trips?", answer: "Yes, we provide Ertiga rentals from Mumbai to Pune, Lonavala, Nashik, Shirdi, Surat, and many other cities." },
  { question: "Are Ertiga vehicles air-conditioned?", answer: "Yes, all Ertiga vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide drivers with the vehicle?", answer: "Yes, all Ertiga rentals include professional drivers experienced in city and highway travel." },
  { question: "Can I book Ertiga for full-day travel?", answer: "Yes, we offer full-day and multi-day rental packages for Ertiga in Mumbai." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "We booked an Ertiga from Omshree Cabs for our Mumbai to Lonavala trip. The car was spacious and very comfortable for our family.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback:
      "Excellent Ertiga rental service in Mumbai. Clean car, professional driver, and smooth travel experience.",
    rating: 5
  }
];



















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Mumbai",
  "description": "Omshree Cab offers Maruti Ertiga on rent in Mumbai for local travel, airport transfers, outstation trips, one-way journeys, and round trips. Choose from family, corporate, and affordable cab options with transparent per km rates and easy online booking for a safe and comfortable Ertiga rental experience across Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2500"
  }
};



  return (
    <div>
      
<Helmet>
  <title>Ertiga On Rent in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides Ertiga on rent in Mumbai for local travel, airport, outstation, one-way, and round trips. Family, corporate, and affordable cab options with transparent per km rates and easy online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinmumbai;